/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { deepmerge } from 'deepmerge-ts'
import { forkJoin, Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { ConfigService } from './configuration/config.service'

export function HttpLoaderFactory(_http: HttpClient, _configService: ConfigService) {
  return new MultiTranslateHttpLoader(_http, [_configService.getTranslationsUrl, _configService.getTranslationsUrlSharedWebComponents])
}

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private _httpClient: HttpClient,
    private url: string[],
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const requests: Observable<any>[] = this.url.map((u) => {
      const path = `${u}${lang}.json`
      return this._httpClient.get(path).pipe(
        catchError(() => {
          return of({})
        }),
      )
    })
    return forkJoin(requests).pipe(map((response) => deepmerge(...response)))
  }
}
